import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { SourceSelect } from "components/select";
import { withRouter } from "react-router-dom";
import { TextDisplay } from "components/display-data";

const SourceChange = ({ source, intl, history }) => {
  const handleCameraChange = useCallback(
    ({ id }) => (source.deployment ? history.push(`/source/viewer/${id}`) : null),
    [history, source.deployment],
  );

  return !source ? null : (
    <TextDisplay label={intl.formatMessage({ id: "app.source.viewer.changeCamera" })}>
      <SourceSelect value={source.id} onChange={handleCameraChange} variables={{ deploymentId: source.deploymentId }} />
    </TextDisplay>
  );
};

SourceChange.propTypes = {
  /**
   * Data to represent
   **/
  source: PropTypes.object,
};

export default withRouter(injectIntl(SourceChange));
